import React from 'react'
import { Explination } from '@enkla-gui'
import { presets } from './presets'
export default function Select({
  controls,
  name,
  options,
  preset,
  label,
  error,
  values,
  onChange = false,
  disabled = false,
  noInitialValue = false,
  clearable = false,
  cols = 'col',
  tip = false,
  placeholder = 'Välj ett alternativ...'
}) {
  const { register, setValue, getValues } = controls
  const resolvedValues = preset ? presets[preset] : values
  if (resolvedValues === undefined) throw Error("Invalid preset: " + preset)
  const id = `field-${name}`
  const errorId = `${id}-error`
  var message
  const hasError = () => {
    var data = error.data
    if (data === undefined) return false
    name.split('.').forEach(value => {
      if (value in data) {
        data = data[value]
      } else {
        data = []
      }
    })
    if (data.length === 0) return false
    message = data[0]
    return true
  }
  const showError = error && hasError()
  return (
    <div class={`component_Select ${cols}`}>
      <div class={`form-group ${disabled ? 'form-group-disabled' : ''}`}>
        <label htmlFor={id}>
          {label}
          {options?.required && <span class='input-required'> * </span>}
          {tip && <Explination tip={tip} />}
        </label>
        {!disabled && clearable && (
          <button
            type='button'
            onClick={() => {
              if (onChange) {
                onChange(null)
              }
              setValue(name, null)
            }}
            class='select-clear'
            aria-label='Rensa val'>
            <i class='fas fa-times' aria-hidden="true" />
          </button>
        )}
        <select
          onInput={e => onChange && onChange(e.target.value)}
          {...register(name, options)}
          id={id}
          type='select'
          class='form-select'
          disabled={disabled}
          defaultValue={resolvedValues[0]?.value}
          aria-invalid={showError ? 'true' : undefined}
          aria-describedby={showError ? errorId : undefined}
          aria-required={options?.required ? 'true' : undefined}
        >
          <option disabled={noInitialValue} selected={clearable && getValues && values.filter(value => value.value === getValues(name)).length === 0} value=''>
            {placeholder}
          </option>
          {resolvedValues.map(
            value =>
              !value.hidden && (
                <option selected={value.selected} value={value.value}>
                  {value.key}
                </option>
              )
          )}
        </select>
        {showError && (
          <div class='form-inline-error' id={errorId}>
            <i class='fa fa-fw fa-exclamation-triangle' aria-hidden="true" />
            {message}
          </div>
        )}
      </div>
    </div>
  )
}
